import { CreateUserForm } from '../../components/admin/CreateUserForm';
import { UserDashboard } from '../../components/dashboard/UserDashboard';

export default function SystemAdminDashboard(): React.JSX.Element {
  return (
    <UserDashboard
      role="system-admin"
      title="System administration"
      description="Account and platform administration."
    >
      <CreateUserForm />
    </UserDashboard>
  );
}
